import { absolutePath } from "./absolutePath";

export const eventLiveStreams = {
  create: () => absolutePath("events/live_streams"),
};
